import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledHeader = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
`;

const Header = (props) => {
    return (
        <StyledHeader>
            { props.children }
        </StyledHeader>
    );
};

Header.propTypes = {
    children: PropTypes.node,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/ui/general/Header.js